module.exports = __webpack_public_path__ + "static/media/banner1.524ebc0c.jpg";